import ResetPasswordPage from '@/features/auth/pages/reset-password'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { XCircle } from "lucide-react"
import {
    Alert,
    AlertDescription,
    AlertTitle,
  } from "@/components/ui/alert"

export const Route = createFileRoute('/(auth)/__auth/reset-password')({
  component: RouteComponent,
  validateSearch: z.object({
    token: z.string().min(1),
  }),
  errorComponent: () => {
    return <TokenError />
  }
})

function RouteComponent() {
  return <ResetPasswordPage />
}


export function TokenError() {
  return (
    <Alert className='bg-inherit border-none shadow-none p-0 m-0'>
      <XCircle className="h-4 w-4 inline-flex my-auto" />
      <AlertTitle className='text-lg'>Error</AlertTitle>
      <AlertDescription className='text-base'>
        Invalid token or token expired
      </AlertDescription>
    </Alert>
  )
}
